module.exports = __webpack_public_path__ + "static/img/pin-trap-scheduled.c316c74.svg";